module.exports = __webpack_public_path__ + "img/ci_1.a243f154.png";